var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1599 51.6297L45.1886 51.6434H45.2029L31 59.417L16.8042 51.6434H16.7898L16.84 51.6229L5.16663 45.2086V16.792L31 2.58364L56.8333 16.792V45.2086L45.1599 51.6297ZM28.9003 8.34895L18.6458 13.9913L9.59759 19.3425L9.35872 28.5548V40.5021L28.9003 29.7571V8.34895ZM11.3795 44.0132L21.0321 49.3277L31 54.3169L40.9535 49.3414L50.6419 44.0132L31.0143 33.2204L11.3795 44.0132ZM52.6412 28.5207L52.4023 19.3425L43.4114 14.0255L33.0996 8.35578V29.7434L52.6412 40.4885V28.5207Z",
    fill: "#A3ABB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3813 16.9557V34.2288C25.3813 35.4059 24.4271 36.3601 23.25 36.3601C22.073 36.3601 21.1188 35.4059 21.1188 34.2288V24.3769L17.6313 26.4113V38.7497C17.6313 39.9267 16.6771 40.8809 15.5 40.8809C14.323 40.8809 13.3688 39.9267 13.3688 38.7497V23.963L25.3813 16.9557Z",
    fill: "#A3ABB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDRoom);
export default __webpack_public_path__ + "static/media/ThreeDRoom.205eba089cd8aaa134761e0e4fc1f969.svg";
export { ForwardRef as ReactComponent };